import React from "react"
import qs from "query-string"
import PropTypes from "prop-types"
import { Redirect } from "@gatsbyjs/reach-router"
import { isAuthenticated } from "../utils"

export default function AuthRedirect({ location }) {
  React.useEffect(() => {
    const searchQuery = location.search
    const query = qs.parse(searchQuery)
    let skipExpirationSet = false

    if (query.token) {
      localStorage.setItem(`gatsby:token`, query.token)

      // If the token has an expiration, set it as gatsby:token-expiration
      const jwtPayload = JSON.parse(atob(query.token.split(".")[1]))
      if (jwtPayload.exp) {
        const date = new Date(jwtPayload.exp * 1000).toISOString()
        localStorage.setItem(`gatsby:token-expiration`, `${date}`)
        skipExpirationSet = true
      }
    }

    // Use the query expiration time only if not set in the token
    if (!skipExpirationSet) {
      if (query.expiration) {
        localStorage.setItem(`gatsby:token-expiration`, query.expiration)
      }
    }

    if (query.ssoToken) {
      localStorage.setItem(`gatsby:ssotoken`, query.ssoToken)

      if (query.ssoExpiration) {
        localStorage.setItem(`gatsby:ssotoken-expiration`, query.ssoExpiration)
      }
    }

    if (query.id) {
      localStorage.setItem(`gatsby:userid`, query.id)
    }
  }, [])

  const { search: searchQuery, origin } = location

  const query = qs.parse(searchQuery)

  const {
    token,
    loginRedirectUrl,
    selectedPlan,
    organizationId,
    new_user,
    ssoToken,
  } = query

  if (token || isAuthenticated()) {
    if (new_user) {
      return <Redirect to={`/dashboard/welcome?${searchQuery}`} noThrow />
    }

    if (!selectedPlan && Boolean(organizationId) && !ssoToken) {
      return (
        <Redirect to={`/dashboard/welcome/upgrade/${organizationId}`} noThrow />
      )
    }

    if (loginRedirectUrl) {
      const { search, pathname } = createLoginRedirectUrlObject(
        origin,
        loginRedirectUrl
      )
      const stringifiedQuery = createLoginRedirectQuery(search)

      return <Redirect to={`${pathname}?${stringifiedQuery}`} noThrow />
    }

    return <Redirect to={`/dashboard/sites?loggedin=1`} noThrow />
  } else {
    return <Redirect to="/dashboard/login" noThrow />
  }
}

AuthRedirect.propTypes = {
  location: PropTypes.object,
}

export function createLoginRedirectUrlObject(origin, loginRedirectUrl) {
  return new URL(`${origin}${loginRedirectUrl}`)
}

export function createLoginRedirectQuery(search, isNewUser) {
  const redirectQuery = qs.parse(search)

  redirectQuery.loggedin = `1`
  if (isNewUser) {
    redirectQuery.new_user = `1`
  }

  return qs.stringify(redirectQuery)
}
